import React from "react";
import { createApi } from "../../../utils/createApi";

/**
 * Fetches the camera's current preview image while `open` is true. Action-log
 * previews draw historical zones/lines over this image — the frame from the
 * time of the change isn't stored.
 */
export const useCameraPreviewUrl = (open: boolean, cameraId: string) => {
  const [previewUrl, setPreviewUrl] = React.useState<string | null>(null);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);

  React.useEffect(() => {
    if (!open || !cameraId) return;

    let cancelled = false;
    setLoading(true);
    setError(null);
    setPreviewUrl(null);

    const AxiosUI = createApi(``);
    AxiosUI.get(`/camera/${cameraId}/status/`)
      .then((response: { data: { preview_url?: string } }) => {
        if (cancelled) return;
        setPreviewUrl(response.data.preview_url ?? null);
      })
      .catch((err: { message?: string }) => {
        if (!cancelled) {
          setError(err?.message ?? "Failed to load camera preview.");
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [open, cameraId]);

  return { previewUrl, loading, error };
};
